(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["candent-equipment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('candent-equipment')) {
  customElements.define('candent-equipment', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.querySelectorAll('.cdfp-feature-image img').forEach(img => {
        const markPortrait = () => {
          if (img.naturalHeight > img.naturalWidth) img.setAttribute('data-equipment-portrait', '');
        };
        if (img.complete && img.naturalWidth) markPortrait();
        else img.addEventListener('load', markPortrait, { once: true });
      });
      const dialog = this.querySelector('dialog');
      const canZoom = dialog && typeof dialog.showModal === 'function';
      const enlarged = canZoom ? dialog.querySelector('img') : null;
      if (canZoom) this.querySelectorAll('.cdeq-description img').forEach(img => {
        if (!img.closest('a, button')) {
          img.classList.add('cdeq-inline-zoom');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cdeq-inline-zoom-button';
          button.setAttribute('aria-label', dialog.getAttribute('aria-label') + ': ' + img.alt);
          button.setAttribute('data-equipment-inline-zoom', '');
          img.replaceWith(button);
          button.append(img);
        }
      });
      this.querySelectorAll('[data-video-id] img').forEach(image => {
        image.addEventListener('error', () => { image.hidden = true; });
        if (image.complete && image.naturalWidth === 0) image.hidden = true;
      });
      this.querySelectorAll('[data-video-id]').forEach(button => {
        button.addEventListener('click', () => {
          if (!/^[A-Za-z0-9_-]{11}$/.test(button.dataset.videoId || '')) return;
          const frame = document.createElement('iframe');
          frame.className = 'cdeq-video';
          frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(button.dataset.videoId) + '?autoplay=1&rel=0';
          frame.title = button.dataset.videoTitle;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          frame.allowFullscreen = true;
          button.replaceWith(frame);
          frame.focus();
        });
      });
      if (!canZoom || !enlarged) return;
      let zoomTrigger = null;
      dialog.addEventListener('close', () => {
        enlarged.removeAttribute('src');
        if (zoomTrigger && zoomTrigger.isConnected) zoomTrigger.focus();
      });
      this.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const trigger = event.target.closest('[data-equipment-zoom], [data-equipment-inline-zoom]');
        if (!trigger) return;
        const img = trigger.querySelector('img');
        if (!img) return;
        event.preventDefault();
        zoomTrigger = trigger;
        enlarged.src = trigger.href || img.dataset.zoomSrc || img.currentSrc || img.src;
        enlarged.alt = img.alt;
        if (!dialog.open) dialog.showModal();
      });
      dialog.querySelector('[data-equipment-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
